import React from 'react'
import { getDefaultName } from '../utils';

export default function DegreeProgress({ question_item}) {

    function BadgeClass(){
        
        if (question_item.avg <3){
          
            return "badge bg-red mt-14";
        }
        else if (question_item.avg  <6) {
            return "badge bg-yellow mt-14";
        }
        else if (question_item.avg  < 8) {
            return "badge bg-light-blue mt-14";
        }
        else if (question_item.avg  <=10) {
            return "badge bg-green mt-14";
        }

        
    }

    const ProgressClass=()=>{
        if (question_item.avg  < 3) {

            return "progress-bar progress-bar-danger";
        }
        else if (question_item.avg  < 6) {
            return "progress-bar progress-bar-yellow";
        }
        else if (question_item.avg  < 8) {
            return "progress-bar progress-bar-primary";
        }
        else if (question_item.avg  <= 10) {
            return "progress-bar  progress-bar-success";
        }
        
    }

    
    
    return (
        <tr >
            <td style={{  paddingLeft:20 }}>
                <small title={`Weight: ` + question_item.question.weight }>{getDefaultName(question_item.question?.names)}</small>
                <div className="progress progress-xs progress-striped">
                    <div className={ProgressClass()} style={{ width: (question_item.avg*10)+"%" }}></div>
                </div>
            </td>
            <td >
                <span className={BadgeClass()}>{question_item.avg} </span>
            </td>
        </tr>
    )
}
